export default {"id":"2333b293","attrs":{"viewBox":"0 0 512 512","width":"512","height":"512"}}